import { AnalyticsEvent, generateInsertId } from '../../common/Analytics';
import { DelayedAction, ReplicantAsyncActionAPI } from '../ReplicantAPI';

export type ReportingAPI = Pick<ReplicantAsyncActionAPI<any>, 'reportError' | 'sendAnalyticsEvents'>;

export function createReportingAPIs(opts: {
    apiAccess: {
        dateNow: () => number;
        reportError: (e: Error, extraContext?: { [key: string]: any }) => Promise<void>;
    };
    delayedActions: DelayedAction[];
    id: string;
    sessionId: string;
}): ReportingAPI {
    const { apiAccess, delayedActions, id, sessionId } = opts;

    return {
        reportError: (e, ctx) =>
            delayedActions.push({
                type: 'action',
                action: () => apiAccess.reportError(e, ctx),
                apiMethodName: 'api.reportError',
            }),

        sendAnalyticsEvents: (events) => {
            const analyticsEvents: AnalyticsEvent[] = [];
            for (const event of events) {
                analyticsEvents.push({
                    user_id: event.userId || id,
                    event_type: event.eventType as any,
                    event_properties: event.eventProperties,
                    user_properties: event.userProperties,
                    insert_id: event.insertId ?? generateInsertId(id, sessionId),
                    time: event.time ?? apiAccess.dateNow(),
                });
            }

            delayedActions.push({ type: 'sendAnalyticsEvents', events: analyticsEvents });
        },
    };
}
